import React from 'react'

import Base from '../_Base'

const CrMark = (props) => (
  <Base width="24" height="24" viewBox="0 0 48 48" fill="none" {...props}>
    <g clipPath="url(#logo)" fill="#000" className="cr-logo-mark">
        <path d="M5.818 26.871c.01-11.65 9.466-21.086 21.117-21.073 11.153.01 20.275 8.678 21.022 19.638.028-.467.043-.94.043-1.413C48.014 10.77 37.28.013 24.024 0 10.768-.014.014 10.721 0 23.976-.014 37.23 10.721 47.987 23.976 48c.548 0 1.092-.018 1.63-.054-11.051-.676-19.8-9.856-19.788-21.076z"/>
        <path d="M38.386 27.183a8.2 8.2 0 0 1-8.19-8.209 8.204 8.204 0 0 1 5.424-7.71 17.922 17.922 0 0 0-8.375-2.072c-9.95-.01-18.022 8.047-18.032 17.995-.01 9.95 8.047 18.022 17.995 18.032 9.948.01 18.022-8.046 18.032-17.996 0-1.127-.103-2.23-.301-3.301a8.187 8.187 0 0 1-6.554 3.261h.001z"/>
    </g>
    <defs>
        <clipPath id="logo">
            <path fill="#fff" d="M0 0h48v48.001H0z"/>
        </clipPath>
    </defs>
  </Base>
)

export default CrMark
